import { Grid, Stack } from '@razz-team/ui-web';
import { VaultSummary } from './VaultSummary';
import { VaultRewards } from './VaultRewards';
import { VaultExchangeRate } from './VaultExchangeRate';
import { MainLayout } from '../../Layout/MainLayout';
import { Route } from '../../../routes/account.vaults_.$vaultId';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useVaultQuery } from '../../../api/vaults';
import { useTranslation } from 'react-i18next';
import { LastTransactions } from '../AccountPage/LastTransactions';

export function VaultPage() {
  const { t } = useTranslation();
  const { vaultId } = Route.useParams();
  const vaultQuery = useVaultQuery({ vaultId });

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={t('Vault {{currency}}', { currency: vaultQuery.data?.balance.currency })}
          loading={vaultQuery.isPending}
          parent={{
            to: '/account/vaults',
            title: t('Earning vaults'),
          }}
        />
      }
    >
      <Grid size={12}>
        <VaultSummary vaultId={vaultId} />
      </Grid>
      <Grid size={{ sm: 6, xs: 12 }}>
        <Stack spacing={2} width="100%">
          <VaultExchangeRate vaultId={vaultId} />
          <VaultRewards vaultId={vaultId} />
        </Stack>
      </Grid>
      <Grid size={{ sm: 6, xs: 12 }}>
        <LastTransactions vaultId={vaultId} />
      </Grid>
    </MainLayout>
  );
}
